import React from "react";
import {Box, Colors} from "@bounce/shared/ui";

type Props = {
  value: string;
  onChange: (next: string) => void;
};

const MatchToggle: React.FC<Props> = ({value, onChange}) => (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      backgroundColor: Colors.tertiary._200,
      borderRadius: "8px",
      border: `1px solid ${Colors.tertiary._200}`,
      height: 36,
      p: "3px",
    }}
  >
    <Box
      sx={{
        position: "absolute",
        top: 3,
        left: value === "all" ? 3 : "50%",
        width: "calc(50% - 3px)",
        height: "calc(100% - 6px)",
        backgroundColor: Colors.bw.white,
        borderRadius: "6px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        transition: "left 0.2s ease",
      }}
    />
    {(["all", "any"] as const).map((opt) => (
      <Box
        key={opt}
        onClick={() => onChange(opt)}
        sx={{
          position: "relative",
          zIndex: 1,
          px: 2,
          py: 0.5,
          borderRadius: "6px",
          fontSize: 13,
          fontWeight: value === opt ? 600 : 400,
          color: value === opt ? Colors.grey._900 : Colors.grey._600,
          cursor: "pointer",
          userSelect: "none",
          transition: "color 0.2s ease, font-weight 0.2s ease",
        }}
      >
        {opt === "all" ? "Match all rules" : "Match any rules"}
      </Box>
    ))}
  </Box>
);

export default MatchToggle;
